// Discovery AI may return helper-language itemName + employer-language itemNameEmployer.
// When live translation is unavailable, pick the label that matches the viewer language.
import { LANGUAGE } from '../constants/index.js';
const CJK_REGEX = /[\u4e00-\u9fff]/;
export const textContainsCjk = (text) => CJK_REGEX.test(text);
export const viewerLanguagePrefersCjk = (language) => language === LANGUAGE.ZH_HANT || language === LANGUAGE.ZH_HANS;
export const resolveBilingualInventoryItemEmployerFallback = (params) => {
    const itemName = params.itemName.trim();
    const employerDisplay = params.itemNameEmployerDisplay.trim();
    if (employerDisplay === '') {
        return itemName;
    }
    if (itemName === employerDisplay) {
        return employerDisplay;
    }
    const viewerCjk = viewerLanguagePrefersCjk(params.viewerLanguage);
    const displayCjk = textContainsCjk(employerDisplay);
    const nameCjk = textContainsCjk(itemName);
    if (viewerCjk) {
        if (displayCjk) {
            return employerDisplay;
        }
        if (nameCjk) {
            return itemName;
        }
        return employerDisplay;
    }
    if (!nameCjk) {
        return itemName;
    }
    if (!displayCjk) {
        return employerDisplay;
    }
    return itemName;
};
//# sourceMappingURL=inventoryItemBilingualDisplay.js.map